import React from "react";
import { Typography } from "@mui/material";
import { CommonFileUploadHintProps } from "./CommonFileUploadInfoTypes";
import { t } from "i18next";

const CommonFileUploadHint: React.FC<CommonFileUploadHintProps> = ({
  supportedTypes,
  maxFiles = 1,
  isImageOrVideo = false,
  fontSize = 14,
}) => {
  const readableFileTypes = supportedTypes.join(", ");
  const fileSize = isImageOrVideo
    ? t("commonFileUploadHintMessages.imageOrVideo")
    : t("commonFileUploadHintMessages.file");

  return (
    <Typography color="text.secondary" fontSize={fontSize}>
      {t("commonFileUploadHintMessages.supportedTypesLabel")}{" "}
      {readableFileTypes}, {t("commonFileUploadHintMessages.maxFilesLabel")}{" "}
      {maxFiles}, {t("commonFileUploadHintMessages.fileSizeLabel")} {fileSize}.
    </Typography>
  );
};

export default CommonFileUploadHint;
